import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { activeChain } from "@/src/configs/chainConfig";
import { fmt } from "@/src/lib/utils";


export const Recharge = () => {
  const { chain } = useAccount();
  const {  onChargeReborn, onChargePendingRewards } = useStake();
  const { isConnected } = useAccount();
  const { frbBalance, unCharged, chargeReborn, pendingRewards} = useBalances();

  const [{ isStake, placeholder }] = useState({
    isStake: true,
    placeholder: "Amount of Flare Reborn NFTs",
  });
  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);

  const [{ stakeInputReborn }, setInput] = useState({
    stakeInput: "",
    unstakeInput: "",
    stakeInputReborn:"",
  });

  const onInputChangeReborn = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = isStake ? value : stakeInputReborn;
    setInput({
      stakeInputReborn: _stakeInput,
      unstakeInput:_stakeInput,
    });
  };

  const onMaxBalance = () => {
    var balance = 0;
    if(parseInt(unCharged) > 0){
      balance = parseInt(unCharged);
    }

    if (isStake)
      return setInput((prev) => ({
        ...prev,
        stakeInputReborn: balance,
      }));
    setInput((prev) => ({
      ...prev,
      unstakeInputReborn: balance,
    }));
  };

  const handleSubmitReborn = async (event) => {
    event.preventDefault();
    if (!isConnected) return;
    if (isStake)
      return toast.promise(onChargeReborn(stakeInputReborn), {
        loading: "Transaction is in progress",
        success: "Successfully charged Flare Reborn NFTs",
        error: (data) => data,
      });
  };
  const chargePending = async (event) => {
    event.preventDefault();
    if (!isConnected) return;
    if (isStake)
      return toast.promise(onChargePendingRewards(stakeInputReborn), {
        loading: "Transaction is in progress",
        success: "Successfully charged Flare Reborn NFTs",
        error: (data) => data,
      });
  };


  return (
    <div className="border border-border max-w-xl mx-auto w-full rounded-2xl bg-card/50 backdrop-blur-sm p-4 sm:p-6 space-y-6">
      <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider text-center">
        Flare Reborn NFT
      </h2>

      <div className="flex justify-center">
        <div className="rounded-2xl overflow-hidden border border-border bg-secondary/30 p-2 shadow-lg mx-auto w-fit">
          <img src={process.env.PUBLIC_URL + 'CRF_KEY.gif'} className="w-full max-w-[280px] h-auto rounded-xl" alt="Reborn NFT" />
        </div>
      </div>

      <form onSubmit={handleSubmitReborn}>
        <div className="flex w-full">
          <input
            value={stakeInputReborn}
            max={parseFloat(unCharged).toFixed(0)}
            onChange={onInputChangeReborn}
            placeholder={placeholder}
            className="w-full bg-secondary/50 border border-border border-r-0 rounded-xl rounded-r-none px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all"
            type="number"
            required
          />
          <span className="w-1/5 flex-shrink-0">
            <Button
              type="button"
              onClick={onMaxBalance}
              className="rounded-l-none rounded-r-xl h-full text-xs"
            >
              max
            </Button>
          </span>
        </div>

        <div className="space-y-0 text-sm mt-5 mb-6">
          <div className="flex items-center justify-between py-2.5 border-b border-border/50">
            <span className="text-sm text-muted-foreground">Rechargeable NFTs</span>
            <span className="text-foreground font-semibold font-mono">{fmt(unCharged, 0)}</span>
          </div>
          {unCharged > 0 &&
          <div className="flex items-center justify-between py-2.5 last:border-0">
            <span className="text-sm text-muted-foreground">FRB</span>
            <span className="text-foreground font-semibold font-mono">{fmt(frbBalance)}/{parseInt(stakeInputReborn) * parseInt(chargeReborn)} <span className="text-muted-foreground font-normal text-xs">({chargeReborn} each)</span></span>
          </div>
          }
        </div>

        <div className="space-y-3">
          <Button type="submit" disabled={!isCorrectChain || unCharged===0 || unCharged < stakeInputReborn || frbBalance < Math.floor((parseInt(stakeInputReborn)*parseInt(chargeReborn))) || stakeInputReborn===0}>Recharge with FRB</Button>
          <Button type="button" onClick={chargePending} disabled={!isCorrectChain || unCharged===0 || unCharged < stakeInputReborn || pendingRewards < Math.floor((parseInt(stakeInputReborn)*parseInt(chargeReborn))) || stakeInputReborn===0} className="bg-secondary hover:bg-secondary/80 text-foreground">Recharge with pending rewards</Button>
        </div>
      </form>
    </div>
  );
};
